import React from 'react';

import { FormFreezeContainer } from './css';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';

import FromBlock from './components/formBlock';

const FormFreeze = () => {
  const {
    manageAccount: { accessControlFormsList }
  } = useLocalizedStringsContext();

  return (
    <FormFreezeContainer>
      {accessControlFormsList.map(item => (
        <FromBlock data={item} />
      ))}
    </FormFreezeContainer>
  );
};

export default FormFreeze;
